import { useCurrencyContext } from "../contexts/CurrencyContext";

export const useCurrency = () => {
  return useCurrencyContext();
};

export default useCurrency;
